import { Dispatch } from 'react-redux';
import { AxiosError } from 'axios';
import { AuthActionCreators, IApplicationState } from '.';
import { ISystemConfig } from '../models';
import * as _ from 'lodash';

export interface ISystemConfigResponse {
    data: {
        success: boolean,
        message: string,
        results: ISystemConfig[]
    }
}

export const ActionCreators = {
    getByList: (list: number[]) => async (dispatch: Dispatch<IApplicationState>): Promise<ISystemConfigResponse> => {
        let l = _.join(list.map(item => 'list=' + item), '&');

        let options = {
            url: __API__ + '/system-config/by-list?' + l
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
}

export interface ISystemConfigState {
}

var initialState: ISystemConfigState = {
};


const createReducer = (initialState: ISystemConfigState, handlers: any) => {
    return function reducer(state = initialState, action: any) {
        if (handlers.hasOwnProperty(action.type)) {
            let s = Object.assign({}, state);
            return handlers[action.type](s, action);
        } else {
            return state;
        }
    }
}

const handlers = {
};

export const Reducer = createReducer(initialState, handlers);
